const { formatCurrency } = await window.importScript(window.scriptUrls["helpers"]);
const {  computed } = await window.importScript(window.scriptUrls["vue3-esm"]);
export default {
    template: "#vue3-product-price-template",
    delimiters: ['${','}'],
    props: {
        product:{
            type: Object,
            default: null
        },
        selectedVariant: {
            type:  Object,
            default: null
        },
        "class": {
            type: [String, Object],
            default: ''
        }
    },

    setup(props) {
        
        const selectVariantOriginalPrice = computed(() => {
            return props.selectedVariant.compare_at_price ? props.selectedVariant.compare_at_price : props.selectedVariant.price;
        });

        const selectedVariantPrice = computed(() => props.selectedVariant.price);


        return {
            props,
            formatCurrency,
            selectedVariantPrice,
            selectVariantOriginalPrice
        }
    }
    
}